import { useEffect } from "react";

const Loader = () => {

  useEffect(()=> {
    const handler = (e: KeyboardEvent) => {
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp' || e.key === 'ArrowLeft' || e.key === 'ArrowRight') {
        e.preventDefault(); 
        e.stopPropagation()
      }
    }
    window.document.body.addEventListener('keydown', handler);
    return () => {
      window.document.body.removeEventListener('keydown', handler);
    }
  }, []);

  return (
    <div className="loader-container">
      <div className="loader"></div>
    </div>
  )
}

export default Loader;
